enum NivelSincronizacao {
  Essencial = 1,
  Estendido = 2,
  Completo = 3,
}

export default NivelSincronizacao;
